// extracted by mini-css-extract-plugin
module.exports = {"theComp":"TabMedia_theComp__PcipQ"};